import React from 'react';

import * as S from './styled';

const Textarea = props => (
  <S.TextareaContainer
    {...props}
  />
);

Textarea.defaultProps = {
  minRows: 2,
};

export default Textarea;
